import axios from 'axios'
import {
  reset,
  loginFailure,
  loginStart,
  loginSuccess,
  createUserFailure,
  createUserSuccess,
  getUserSuccess,
  getUserFailure,
  updateUserSuccess,
  updateUserFailure,
  uploadResourceSuccess,
  uploadResourceFailure
} from './AuthActions'
import { apiUrl, resetPasswordLink } from '../constants/constants'
import { useHistory } from 'react-router-dom'
export const login = async (user, dispatch) => {
  dispatch(loginStart())
  try {
    const res = await axios.post(apiUrl + '/affiliate/signin', user)

    dispatch(loginSuccess(res.data))
  } catch (err) {
    dispatch(loginFailure({ message: err.response }))
  }
}

export const resetPassword = async (user, dispatch) => {
  dispatch(loginStart())
  try {
    const res = await axios.post(apiUrl + '/affiliate/resetPassword', user)
    alert(res.data.message)
    window.location.href = `${resetPasswordLink}/login`
    // console.log(res)
    // dispatch(loginSuccess(res.data))
  } catch (err) {
    dispatch(loginFailure({ message: "Email doesn't exist" }))
  }
}

export const createUploadResource = async (formData, dispatch) => {
  dispatch(reset())
  try {
    const res = await axios.post(
      apiUrl + '/affiliate/multipleFile',
      formData[0],
      formData[1]
    )
    dispatch(uploadResourceSuccess({ message: res }))

    // res.data.result.isAdmin && dispatch(loginSuccess(res.data))
  } catch (err) {
    console.log(err)
    dispatch(uploadResourceFailure({ message: err.response }))
  }
}
export const getUserById = async (userId, dispatch) => {
  // dispatch(reset())

  try {
    const res = await axios.get(`${apiUrl}/affiliate/getUserById/${userId}`)

    if (res.data.success) {
      dispatch(getUserSuccess({ message: res, data: res.data }))
    }
  } catch (error) {
    dispatch(getUserFailure({ message: error.response }))
  }
}
export const updateUser = async (data, dispatch) => {
  dispatch(reset())
  try {
    const res = await axios.put(apiUrl + '/affiliate/updateUser', data)

    dispatch(updateUserSuccess({ message: res, data }))

    // res.data.result.isAdmin && dispatch(loginSuccess(res.data))
  } catch (err) {
    console.log(err)
    dispatch(updateUserFailure({ message: err.response }))
  }
}

export const createUser = async (user, dispatch) => {
  dispatch(reset())
  try {
    const res = await axios.post(apiUrl + '/affiliate/createUser', user.data)

    dispatch(createUserSuccess({ message: res }))

    // res.data.result.isAdmin && dispatch(loginSuccess(res.data))
  } catch (err) {
    console.log(err)
    dispatch(createUserFailure({ message: err.response }))
  }
}

export const createNewAffiliate = async (user, dispatch) => {
  dispatch(reset())
  try {
    const res = await axios.post(
      apiUrl + '/affiliate/createNewAffiliate',
      user.data
    )

    dispatch(createUserSuccess({ message: res }))

    // res.data.result.isAdmin && dispatch(loginSuccess(res.data))
  } catch (err) {
    console.log(err)
    dispatch(createUserFailure({ message: err.response }))
  }
}

export const logout = async (user, dispatch) => {
  //dispatch(logoutSuccess())
}
